import { Table, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Content } from '@/core/components';

import { JobTitle, formatDecimal } from '@feature/utils';

import { CriteriaResult } from '../model/MinStdTypes';

interface MinStdCriteriaOverviewProps {
  result: CriteriaResult[];
  jobTitle: JobTitle;
}

export function MinStdCriteriaOverview(props: MinStdCriteriaOverviewProps) {
  const { result, jobTitle } = props;
  const { t } = useTranslation();

  return (
    <Content type="full">
      <Text
        fw="500"
        size="lg"
      >
        {t('minStd.criteria.criteria')}
      </Text>
      <Table
        bg="white"
        style={{ borderRadius: '12px' }}
        striped
        highlightOnHover
        withTableBorder
        withColumnBorders
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t('minStd.criteria.criteriaCode')}</Table.Th>
            <Table.Th>{t('minStd.criteria.title')}</Table.Th>
            <Table.Th>
              {t('minStd.criteria.minPointsFor')}: {t(`jobTitleEnum.${jobTitle}`)}
            </Table.Th>
            <Table.Th>{t('minStd.criteria.points')}</Table.Th>
            <Table.Th>{t('minStd.criteria.passed')}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {result.map(({ criteria, totalScore, passed, minimumPointsForGivenJobTitle }) => (
            <Table.Tr key={criteria.criteriaCode}>
              <Table.Td>{criteria.criteriaCode}</Table.Td>
              <Table.Td>{criteria.title}</Table.Td>
              <Table.Td ta="right">{minimumPointsForGivenJobTitle}</Table.Td>
              <Table.Td ta="right">{formatDecimal(totalScore)}</Table.Td>
              <Table.Td ta="right">{passed ? 'DA' : 'NU'}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Content>
  );
}
